<mat-chip-listbox class="w-full p-3 m-auto" aria-label="Files selected">
  <div *ngFor="let item of files; index as i" class="flex flex-row gap-2 items-center">
    <mat-chip-option (removed)="remove(item)">
      <ng-container [ngSwitch]="true">
        <ng-template [ngSwitchCase]="item.assetType === AssetTypeEnum.Image">
          <img [attr.src]="item.previewUrl | imageLoading | async" i18n-alt alt="Preview image" class="preview-image" />
        </ng-template>
        <ng-template [ngSwitchCase]="item.assetType === AssetTypeEnum.Video || item.assetType === AssetTypeEnum.PDF">
          <img [attr.src]="item.imageUrl | imageLoading | async" i18n-alt alt="Preview image" class="preview-image" />
        </ng-template>
        <ng-template [ngSwitchCase]="item.assetType === AssetTypeEnum.Audio">
          <mat-icon class="cursor-pointer mr-2 material-icons-outlined">audiotrack</mat-icon>
        </ng-template>
        <ng-template [ngSwitchCase]="item.assetType === AssetTypeEnum.ZIP">
          <mat-icon class="cursor-pointer mr-2 material-icons-outlined">folder_zip</mat-icon>
        </ng-template>
        <ng-template [ngSwitchCase]="item.assetType === AssetTypeEnum.HtmlBanner">
          <mat-icon class="material-icons-outlined mr-2">html</mat-icon>
        </ng-template>
        <ng-template ngSwitchDefault>
          <ng-template [ngIf]="item.previewUrl" [ngIfElse]="attachmentIcon">
            <img [attr.src]="item.previewUrl" i18n-alt alt="Preview image" class="preview-image" />
          </ng-template>
          <ng-template #attachmentIcon>
            <mat-icon class="orangered-icon mr-2">attachment</mat-icon>
          </ng-template>
        </ng-template>
      </ng-container>
      {{ item.mainFile?.name ? item.mainFile?.name : item.name ? item.name : item.file.name }}
      {{ (item.mainFile?.size ? item.mainFile?.size : item.file.size) | formatFileSize }}
      <mat-icon *ngIf="!item.uploaded" class="orangered-icon ml-2" matChipRemove>close</mat-icon>
      <mat-icon *ngIf="item.uploaded" class="green-icon">done</mat-icon>
    </mat-chip-option>
    <mat-spinner *ngIf="uploadInProgress && item.uploading" [diameter]="20"></mat-spinner>
  </div>
</mat-chip-listbox>
<div *ngIf="uploadInProgress" class="flex flex-col px-2">
  <span>{{ currentUploadFileName }} {{ progress }}%</span>
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
</div>
